<template>
    <div class="portrait-panle" :style="data.position">
        <div class="portrait-select" v-if="isShowParam" @click="paramClickHandle">
            <div class="tag-label">{{ $i18n.t("zhiji.portrait.addParam") }}<i class="el-icon-arrow-right"></i></div>
            <div class="portrait-param">
                <el-select
                    v-model="param"
                    ref="portraitParam"
                    filterable
                    @change="paramChange"
                    :placeholder="$i18n.t('zhiji.portrait.pleaseSeleParam')"
                    popper-class="drow-portrait-select"
                >
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </div>
        </div>
        <div v-if="isShowTag" @click="tagClickHandle" class="tag-part">
            <div class="tag-label">{{ $i18n.t("zhiji.portrait.addTag") }}<i class="el-icon-arrow-right"></i></div>
            <div class="portrait-tag">
                <el-select v-model="tagValue" ref="portraitTag" @change="tagChange" popper-class="drow-tagpart-select">
                    <el-option v-for="item in tagOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
import { queryAndConvertResp } from "@/views/zhiji/js/services/service.js";

export default {
    name: "AddPortraitEdit",
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            param: "", // 画像参数
            options: [],
            tagValue: "", // 画像标签
            tagOptions: []
        };
    },
    computed: {
        isShowParam() {
            return this.data.type ? (this.data.type === "param" ? true : false) : true;
        },
        isShowTag() {
            return this.data.type ? (this.data.type === "tag" ? true : false) : true;
        }
    },
    mounted() {
        // 获取画像参数类型
        this.isShowParam && this.getList();
        // 获取画像标签
        this.isShowTag && this.getTagList();
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        getList() {
            // 目前只支持来源为sdk
            queryAndConvertResp("/xiaoyue-operation/user_profile/param/search", {}, result => {
                this.options =
                    result &&
                    result.list.map(item => ({
                        type: "param",
                        label: item.describe,
                        key: item.name,
                        value: item.id
                    }));
            });
        },
        getTagList() {
            queryAndConvertResp("/xiaoyue-operation/answer/tagClassify", {}, result => {
                this.tagOptions =
                    result &&
                    result.map(item => ({
                        type: "tag",
                        label: item.describe,
                        key: item.name,
                        value: item.id
                    }));
            });
        },
        paramChange(value) {
            const checkItem = this.options.filter(item => item.value === value)[0] || {};
            // eslint-disable-next-line no-unused-expressions
            this.data.callback && this.data.callback(checkItem);
            this.$emit("closeModal");
        },
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.$emit("closeModal");
            }
        },
        paramClickHandle() {
            this.$refs.portraitParam.toggleMenu();
        },
        tagClickHandle() {
            this.$refs.portraitTag.toggleMenu();
        },
        tagChange(value) {
            const checkItem = this.tagOptions.filter(item => item.value === value)[0] || {};
            // eslint-disable-next-line no-unused-expressions
            this.data.callback && this.data.callback(checkItem);
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="scss" scoped>
.portrait-panle {
    position: absolute;
    z-index: 99;
    /deep/.el-icon-arrow-right {
        position: absolute;
        right: 5px;
        top: 12px;
    }
    .el-select {
        width: 100%;
    }
    .tag-label {
        position: absolute;
        width: 100%;
        padding: 8px 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d8e4f0;
        background-color: #fff;
        box-sizing: border-box;
    }
    .tag-part,
    .portrait-param {
        position: relative;
        width: 200px;
        /deep/.el-input {
            opacity: 0;
        }
    }
    .portrait-tag {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 1;
    }
}
</style>
